var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btn d-none d-md-block btn-danger btn-lg",on:{"click":function($event){return _vm.deleteFile(  _vm.fileId )}}},[_c('i',{staticClass:"fas fa-trash"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e18ace2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RemoveFile.vue
// module id = DqrV
// module chunks = 0